/* eslint-disable @typescript-eslint/no-explicit-any */
import { color } from 'asserts/styles/colors';

const useAddCenterDataInDoughnut = () => {
  const getData = (chart: any) => {
    const { ctx, data } = chart;

    const arrayData = data.datasets[0].data;

    const sumData = arrayData.reduce((accumulator: number, currentValue: number) => {
      return accumulator + currentValue;
    }, 0);

    const sumText = `총\n${sumData.toLocaleString()}\n명`;

    ctx.save();
    ctx.font = '12px Noto Sans KR';
    ctx.fillStyle = `${color.black04}`;
    ctx.textAlign = 'center';
    ctx.textBaseLine = 'middle';
    ctx.fillText(`${sumText}`, chart.getDatasetMeta(0).data[0].x, chart.getDatasetMeta(0).data[0].y + 5);
  };

  return getData;
};

export default useAddCenterDataInDoughnut;
